import request from './request'

/**
 * 部门列表
 */
export function getDepts() {
  return request.get('/org/depts')
}

/**
 * 部门树
 */
export function getDeptTree() {
  return request.get('/org/depts/tree')
}

/**
 * 获取部门详情
 * @param {number} id - 部门ID
 */
export function getDept(id) {
  return request.get(`/org/depts/${id}`)
}

/**
 * 新增部门
 * @param {object} data - 部门信息
 * @param {string} data.name - 部门名称
 * @param {number} [data.parentId] - 父部门ID
 * @param {number} [data.orderNum] - 排序号
 * @param {boolean} [data.status] - 状态：true-启用，false-禁用
 */
export function createDept(data) {
  return request.post('/org/depts', data)
}

/**
 * 修改部门
 * @param {number} id - 部门ID
 * @param {object} data - 部门信息
 */
export function updateDept(id, data) {
  return request.put(`/org/depts/${id}`, data)
}

/**
 * 删除部门
 * @param {number} id - 部门ID
 */
export function deleteDept(id) {
  return request.post(`/org/depts/${id}/delete`, { id })
}
